export const inputUnits = {
    "01": "Litres",
    "02": "Meters�",
    "03": "Bar",
    "04": "Millibar",
    "05": "Meters Head (MH2O)",
    "06": "Psi",
    "07": "US Gallons (gal)",
    "08": "Foot�",
    "09": "Litres/sec (l/s)",
    "10": "Meters�/hr",
    "11": "Mega Litres per Day (Ml/d)",
    "12": "Kilopascals (kPa)",
    "13": "Feet Head (ftH2O)",
    "14": "Kilograms/cm�"
}